import { Helmet } from 'react-helmet-async';
import FunnelView from 'src/sections/overview/dashboards/views/funnel';

export default function SearchPerformanceFunnel() {
  return (
    <>
      <Helmet>
        <title>Funnel</title>
      </Helmet>
      <FunnelView />
    </>
  );
}
